import api from "../utils/API";

const getAll = (page, limit = 7) => {
  return api.get(`/candidatsmanagement/candidat/list?page=${page}&limit=${limit}`);
};

const getDetails = (uuid, params = "") => {
  return api.get(`/candidatsmanagement/candidat/${uuid}/details${params}`);
};

const deleteCandidat = (uuid) => {
  return api.delete(`/candidatsmanagement/candidat/${uuid}/delete`);
};

const addCandidat = (data) => {
  return api.post(`/candidatsmanagement/candidat/add`, data);
};
const addCvCandidat = (data) => {
  return api.post(`/candidatsmanagement/candidat/cv/add`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

const editCandidat = (data, uuid) => {
  return api.post(`/candidatsmanagement/candidat/${uuid}/edit`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
};

const searchCandidats = (url, page) => {
  return api.get(`/candidatmanagement/recherche/search?page=${page}&limit=${50}&${url}`);
};

const getAllCandidatsForMission = (mission, isSelected, inactive = false) => {
  const base = `/candidats/mission/list?inactive=${inactive}&mission=${mission}`;
  const url = (isSelected !== null && isSelected !== undefined)
    ? `${base}&isSelected=${isSelected}`
    : base;
  return api.get(url);
};

const getCvCandidat = (pdfFileName) => {
  return api.get(`/candidatsmanagement/candidat/${pdfFileName}`);
};

const getLocations = () => {
  return api.get('/locations')
}

const addLocation = (name) => {
  return api.post('/location/add', name)
}

const getAllCandidatsForReporting = (queryParams = "") => {
  return api.get(`/candidats/mission/list${queryParams}`);
}

const getAllCandidatsForSociete = (uuid) => {
  return api.get(`/societe/${uuid}/candidats/list`);
}

const callCandidat = (payload) => {
  return api.post('/ringover/webhook/call', payload);
}

const sendSmsToCandidat = (payload) => {
  return api.post('/ringover/webhook/push/sms', payload);
}

const disableMailing = (id) => {
  return api.put(`candidatsmanagement/candidat/${id}/disable/mailing`)
}

const getAllWithoutLimit = (search = '') => {
    return api.get(`/candidatsmanagement/candidat/list?page=1&limit=999999&search=${encodeURIComponent(search)}`);
};

const getCandidatsAndContacts = (uuid) => {
  return api.get(`candidatsmanagement/candidat/${uuid}/related`);
}
const formatCvCandidat = (uuid) => {
  return api.post(`/candidatsmanagement/candidat/${uuid}/format-cv`);
}
const getJobsForCandidat = (candidateUuid, mode = 'vecteur', limit = 10) => {
  return api.post('/candidatmanagement/recherche/job-for-candidat', {
    candidate_uuid: candidateUuid,
    mode,
    limit,
  });
};

const rerankJobsForCandidat = (candidateUuid, mode = 'vecteur', limit = 10, shortlistLimit = 30) => {
  return api.post('/candidatmanagement/recherche/job-for-candidat-rerank', {
    candidate_uuid: candidateUuid,
    mode,
    limit,
    shortlist_limit: shortlistLimit,
  });
};

const getEmployabilitySummary = (candidateUuid) => {
  return api.get(`/candidatmanagement/recherche/employability/${candidateUuid}`);
};

const getJobFitAnalysis = (candidateUuid, jobUuid) => {
  return api.get(`/candidatmanagement/recherche/job-fit/${candidateUuid}/${jobUuid}`);
};

// "Approche" tab: LinkedIn prospection progress of a candidate.
const getCandidatApproche = (uuid) => api.get(`/candidatsmanagement/candidat/${uuid}/approche`);
const updateCandidatApproche = (uuid, data) => api.put(`/candidatsmanagement/candidat/${uuid}/approche`, data);

export {
  getCandidatApproche,
  updateCandidatApproche,
  getAll,
  getAllWithoutLimit,
  getDetails,
  editCandidat,
  deleteCandidat,
  addCandidat,
  searchCandidats,
  getAllCandidatsForMission,
  getCvCandidat,
  getAllCandidatsForReporting,
  getAllCandidatsForSociete,
  callCandidat,
  addCvCandidat,
  sendSmsToCandidat,
  disableMailing,
  getCandidatsAndContacts,
  getLocations,
  addLocation,
  formatCvCandidat,
  getJobsForCandidat,
  rerankJobsForCandidat,
  getEmployabilitySummary,
  getJobFitAnalysis,
};

